import { certificationProcess, basicUserInfo } from '@/api/userinfo.js';
import { Message } from 'element-ui'
import Cookies from 'js-cookie'

const userInfo = {
    state: {
        isLogin: false, //是否已经登录
        messageCount: 0, //账户消息数量
        certificationState: -1, //是否实名认证
        is_agent: 0 //是否代理商
    },
    mutations: {
        //登陆成功后标记
        SET_LOGIN(state, msgCount) {
            state.isLogin = true;
            //同时获取消息数量
            state.messageCount = msgCount;
        },
        // 判断用户是否已登录
        USER_LOGIN(state, loginResult) {
            state.isLogin = loginResult;
        },
        // 退出登录状态
        USER_LOGOUT(state) {
            state.isLogin = false;
        },
        //获取认证状态
        CERTIFICATE_STATE(state, certState) {
            state.certificationState = certState;
        },
        //获取是否代理商
        AGENT_STATE(state, is_agent) {
            state.is_agent = is_agent;
        }
    },
    actions: {
        // 退出登录状态
        async userSignOut({ commit }) {
            Cookies.remove('dls_token')
            commit('USER_LOGOUT')
        },
        //获取认证状态
        async getCertification({ commit }, payload) {
            await certificationProcess().then(res => {
                if (res.data.code == '100001') {
                    commit('CERTIFICATE_STATE', res.data.result.state)
                    if (payload) {
                        //显示message信息
                        Message.info({
                            message: res.data.message,
                            duration: 3
                        })
                    }
                }
            })
        },
        //获取认证状态
        async getAgent({ commit }, payload) {
            await basicUserInfo().then(res => {
                if (res.data.code == '100001') {
                    commit('AGENT_STATE', res.data.result.user.is_agent)
                }
            })
        }
    }
}

export default userInfo


// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js